import { toArray } from "@suse-o11y/to-array";

function isVisible(element: HTMLElement): boolean {
	return element.getClientRects().length > 0 && element.closest("[inert],[aria-hidden='true']") == null;
}

function isFocusable(element: HTMLElement): boolean {
	return (element.tabIndex >= 0 || element.isContentEditable) && !element.matches(":disabled") && isVisible(element);
}

export function getAdjacentFocusable(
	from: Element,
	direction: 1 | -1,
	skipWithin?: HTMLElement,
): undefined | HTMLElement {
	if (!(from instanceof HTMLElement)) {
		return undefined;
	}

	const focusables = toArray(
		document.querySelectorAll<HTMLElement>(
			`a,button,input,select,textarea,[tabindex],[contenteditable],
			[role="button"],[role="link"],[role="checkbox"],[role="radio"],[role="switch"],
			[role="tab"],[role="menuitem"],[role="menuitemcheckbox"],[role="menuitemradio"],
			[role="option"],[role="treeitem"],[role="gridcell"],[role="spinbutton"],
			[role="slider"],[role="combobox"],[role="searchbox"],[role="textbox"]`,
		),
	).filter(isFocusable);
	const currentIndex = focusables.indexOf(from);

	if (currentIndex === -1) {
		return undefined;
	}

	for (let index = currentIndex + direction; index >= 0 && index < focusables.length; index += direction) {
		const candidate = focusables[index];

		if (!skipWithin?.contains(candidate)) {
			return candidate;
		}
	}

	return undefined;
}
